<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', ipi)">
      <v-card v-if="ipi" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} IPI </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="ipi.ncm.id"
                    :items="itens.ncm"
                    :rules="[obrigatorio]"
                    label="NCM *"
                  />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="ipi.descricao"
                    label="Descrição *"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="ipi.cst" label="CST" />
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="ipi.aliquota"
                    label="Alíquota IPI *"
                    :rules="[maiorOuIgualAZero]"
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field v-model="ipi.observacao" label="Observação"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(ipi)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import IPI from '../../models/ipi'
import IPIService from '../../services/ipi/ipi'
import { obrigatorio, maiorOuIgualAZero } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'ipiParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    ipi: new IPI(),
    obrigatorio: obrigatorio,
    maiorOuIgualAZero: maiorOuIgualAZero,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    ipiParam() {
      return this.ipiParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.ipi = new IPI()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.ipi = this.ipiParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const ipiSalvo =
          this.operacao === 'adicionar'
            ? await IPIService.create({ ...data })
            : await IPIService.update(data.id, data)

        this.$emit('confirmado', ipiSalvo)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
